export interface StartupParams {
	passwordResetKey?: string;
	iCareSessionId?: string;
}

export interface MapEntry {
	level: string;
	children?: Record<string, MapEntry>;
}

export type SecurityMap = Record<string, MapEntry>;

export type MapOrEntry = SecurityMap | MapEntry;

export type AccessLevel = 'N' | 'R' | 'G' | 'F' | 'M' | 'L';
export const AccessLevels = {
	None: 'N' as AccessLevel,
	ReadOnly: 'R' as AccessLevel,
	Group: 'G' as AccessLevel,
	Full: 'F' as AccessLevel,
	Mandatory: 'M' as AccessLevel,
	Logout: 'L' as AccessLevel,
};
